import React, {useContext} from "react"
import Footer from "./Footer"
import FooterTop from "./FooterTop"
import SiteContext from "../context/SiteContext"


const IRSFooter = ({...rest}) => {
  
  const {site} = useContext(SiteContext)

  return (
    <Footer footerLinks={site.footerLinks} {...rest}>
      <FooterTop sitemap={site.sitemap} socialLinks={site.socialLinks}/>
    </Footer>
  )

}

export default IRSFooter
